import React, { useState } from 'react';
import { Menu, Dropdown } from 'antd';
import {
    DownOutlined
} from '@ant-design/icons';
import './DropDown.css'

const menu = (
    <Menu style={{ borderRadius: '10px' }} >
        <Menu.Item style={{ padding: '10px 50px' }} >
            <a target="_blank" rel="noopener noreferrer" href="/">
                Profile
            </a>
        </Menu.Item>
        <Menu.Item style={{ padding: '10px 50px' }} >
            <a target="_blank" rel="noopener noreferrer" href="/">
                Activites
            </a>
        </Menu.Item>
        <Menu.Item style={{ padding: '10px 50px' }} >
            <a target="_blank" rel="noopener noreferrer" href="/">
                Settings
            </a>
        </Menu.Item>
        <Menu.Item danger style={{ padding: '10px 50px' }} >Log out</Menu.Item>
    </Menu>
)

export const DropDown = () => {
    return (
        <>
            <Dropdown overlay={menu} trigger={['click']}>
                <div onClick={e => e.preventDefault()} className="dropdown_wrapper" >
                    <i class="fas fa-user-circle"></i>
                    <a className="ant-dropdown-link">
                        Test User <DownOutlined />
                    </a>
                </div>
            </Dropdown>
        </>
    )
}